import { SearchItem, SearchLogColumn } from './models';

const storeSearch = (searchData: SearchItem[]) => {
  sessionStorage.setItem('logSearchString', JSON.stringify(searchData));
};
const getStoredSearch = (): string =>
  sessionStorage.getItem('logSearchString') ?? '[]';

const clearStoredSearch = () => sessionStorage.removeItem('logSearchString');
const toSearchFormat = (searchItems: SearchItem[]) => {
  try {
    return JSON.parse(
      `{${searchItems
        .filter((item) => item.value.length > 0)
        .map((item) => `"${item.column}":"${encodeURI(item.value)}"`)
        .join(',')}}`,
    );
  } catch (e) {}
  return null;
};
const strToSearchData = (searchString: string, columns: SearchLogColumn[]) => {
  const segments = searchString.trim().split(',');
  const temp: SearchItem[] = [];
  segments.forEach((segment) => {
    if (segment.trim().length > 0) {
      const parts = segment.trim().split(':');
      if (parts.length > 0 && parts[0] && parts[0].trim().length > 0) {
        columns.map((col) => {
          if (
            col.label.trim().toLowerCase() === parts[0].trim().toLowerCase()
          ) {
            temp.push({
              column: col.value,
              value: `${parts[1]?.trim()}`,
            });
          }
          return col;
        });
      }
    }
  });
  return temp;
};

const logSearchHelper = {
  getStoredSearch,
  storeSearch,
  toSearchFormat,
  strToSearchData,
  clearStoredSearch,
};
export default logSearchHelper;
